require('./src/styles/init.scss');